import { createFileRoute } from '@tanstack/react-router';
import OrdersKanbanBoard from '../../components/manager/OrdersKanbanBoard';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/board')({
  component: ManagerBoardRoute,
});

function ManagerBoardRoute() {
  return (
    <ManagerPortal>
      <OrdersKanbanBoard />
    </ManagerPortal>
  );
}

